const EUR_OPTIONS = { style: "currency", currency: "EUR" };

export function formatCurrencyEur(value, locale = "en-GB") {
  const n = Number(value);
  const amount = Number.isFinite(n) ? n : 0;
  const loc = locale || "en-GB";
  try {
    return new Intl.NumberFormat(loc, EUR_OPTIONS).format(amount);
  } catch {
    return new Intl.NumberFormat("en-GB", EUR_OPTIONS).format(amount);
  }
}
